import * as React from 'react';
import LocationListDesktop from './LocationListDesktop';

const LocationListMobile = () => {

    return (<LocationListDesktop/>)
}

export default LocationListMobile